import { Endpoints } from '@/api/ApiEndpoints';
import router from '@/router';
import { Inputs, validationSchema } from '@/entities/Missions/MissionsFormInputs'

const Missions = {
	Plural: 'Missions',
	Single: 'Mission',
	Inputs: Inputs,
	IsPage: true,
	FormWithImage: true,
	Relationships: [

		{
			name: 'type',
			endpoint: Endpoints.MISSION_TYPES,
			mapping: (response) => {
				return response;
			},
		},
		{
			name: 'category',
			endpoint: Endpoints.MISSION_CATEGORIES,
			mapping: (response) => {
				return response;
			},
		},
		{
			name: 'targetValue',
			endpoint: Endpoints.GAMES_FOR_FILTERS_NEW,
			dataMapping: (response) => {

				response.forEach(element => {
					element['gameId'] = element.id;
					element['id'] = element.providerId;
					element['name'] = element.homeTeamName + " - " + element.awayTeamName
				});

				return response;
			},
		},
	],
	TransformDataToSend: (payload, presetMap, results) => {
		if (payload.data.marketTargetShortcut) {
			const preset = presetMap[payload.data.marketTargetShortcut];
			if (preset) {
				results.marketTarget = {
					marketId: preset.marketId,
					oddLabel: preset.oddLabel,
					marketDescription: preset.marketDescription,
				};
			}
			delete results.marketTargetShortcut;

		}
		return results
	},
	shortCuTMapToSent: {
		'ou_0_5_over': { marketId: '7', oddLabel: 'Over', marketDescription: '0.5' },
		'ou_0_5_under': { marketId: '7', oddLabel: 'Under', marketDescription: '0.5' },
		'ou_1_5_over': { marketId: '7', oddLabel: 'Over', marketDescription: '1.5' },
		'ou_1_5_under': { marketId: '7', oddLabel: 'Under', marketDescription: '1.5' },
		'ou_2_5_over': { marketId: '7', oddLabel: 'Over', marketDescription: '2.5' },
		'ou_2_5_under': { marketId: '7', oddLabel: 'Under', marketDescription: '2.5' },
		'ou_3_5_over': { marketId: '7', oddLabel: 'Over', marketDescription: '3.5' },
		'ou_3_5_under': { marketId: '7', oddLabel: 'Under', marketDescription: '3.5' },
		'ou_4_5_over': { marketId: '7', oddLabel: 'Over', marketDescription: '4.5' },
		'ou_5_5_under': { marketId: '7', oddLabel: 'Under', marketDescription: '5.5' },
		'ggng_yes': { marketId: '14', oddLabel: 'Yes', marketDescription: null },
		'ggng_no': { marketId: '14', oddLabel: 'No', marketDescription: null },
		'result_1': { marketId: '1', oddLabel: '1', marketDescription: null },
		'result_x': { marketId: '1', oddLabel: 'x', marketDescription: null },
		'result_2': { marketId: '1', oddLabel: '2', marketDescription: null },
		'ou_any': { marketId: '7', oddLabel: null, marketDescription: null },
		'ggng_any': { marketId: '14', oddLabel: null, marketDescription: null },
		'result_any': { marketId: '1', oddLabel: null, marketDescription: null },
	},
	ValidationSchema: validationSchema,
	SaveCallBack: (id) => {
		//router.push(`/leagues/edit/${id}`)
	}
};

export default Missions;
